import React from "react"

export class LoaderClass extends React.Component {

    render() {

        let { position = 'relative', top = 0, left = 0, marginTop = 5, width = 3, height = 3 } = this.props

        return (
            <>
                <div className={`d-flex justify-content-center text-info mt-${marginTop}`}
                     style={{position: position, top: top, left: left}}>
                    <div className={"spinner-border"} style={{width: `${width}rem`, height: `${height}rem`}} role={"status"}>
                        <span className={"sr-only"}/>
                    </div>
                </div>
            </>
        )
    }
}